__webpack_require__.p = "https://inventory-analytics-ui-qa.capitalone.com/";